// @ts-nocheck

import memoize from 'memoize-state';
import React from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../../hooks/useMergeProps';
import GridsSystemList from '../components/pool/GridsSystemList';
import GridsVirtualizedSystemList from '../components/pool/GridsVirtualizedSystemList';
import { getSystemList } from '../selectors/common';

const legacySelector = memoize(getSystemList);

type GridsSystemListContainerProps = {
  className?: string;
  isPublicGrid?: boolean;
  noVirtualized?: boolean;
  gridReference?: string;
  poolId?: number;
};

const GridsSystemListContainer = ({
  noVirtualized,
  gridReference,
  isPublicGrid,
  ...ownProps
}: GridsSystemListContainerProps) => {
  const { poolId } = ownProps;
  const selectedProps = useSelector((state) => legacySelector(state, { poolId, gridReference, isPublicGrid }));

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  if (noVirtualized) {
    return <GridsSystemList {...enhancedProps} />;
  }

  return <GridsVirtualizedSystemList {...enhancedProps} />;
};

export default GridsSystemListContainer;
